exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".connection-date-image{padding-top:25px;width:100%}@media (min-width:992px){.connection-date-image{width:auto}}", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./~/sass-loader!./src/components/checkout/ConnectionDate/ConnectionDate.scss
 ** module id = 1224
 ** module chunks = 0
 **/